export default "__VITE_ASSET__1e7a0dd2__"